/* 填充下拉框公用方法 */
function getSelectData(parentCode,callBack) {
    let url = '/api/dropDownList/selectByCode'
    console.log(this.$axios)
    this.$axios.http('post', url, {
        parentCode:parentCode
    }, data => {
        if (data.success) {
            var arr = [];
            for(var i = 0; i < data.data.length; i++) {
                if(parentCode == 'PROJECT-STATE') {
                    var obj ={
                        value:data.data[i].attValue,
                        label:data.data[i].attName,
                        bgColor:data.data[i].remark
                    }
                }else {
                    var obj ={
                        value:data.data[i].attValue,
                        label:data.data[i].attName
                    }
                }
                arr.push(obj);
            }
            callBack (arr);
        } else {
            this.$message({
                message: '请求失败',
                center: true
            });
        }

    })
}
export default {
    install: function(vm) {
        vm.prototype.getSelectData = getSelectData;
    }
}


// WEBPACK FOOTER //
// ./src/commonJs/common.js